"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var __1 = __importDefault(require(".."));
var Box_1 = __importDefault(require("../../Box"));
var Button_1 = __importDefault(require("../../Button"));
var Heading_1 = __importDefault(require("../../Heading"));
var Paragraph_1 = __importDefault(require("../../Paragraph"));
function DialogModal(props) {
    var title = props.title, message = props.message, _a = props.actionText, actionText = _a === void 0 ? 'Yes' : _a, _b = props.cancelText, cancelText = _b === void 0 ? 'No' : _b, onAction = props.onAction, onCancel = props.onCancel, rest = __rest(props, ["title", "message", "actionText", "cancelText", "onAction", "onCancel"]);
    return (react_1.default.createElement(__1.default, __assign({}, rest),
        react_1.default.createElement(Content, null,
            react_1.default.createElement(Title, { textAlign: 'center' }, title),
            react_1.default.createElement(Paragraph_1.default.P3, { mb: '100px', textAlign: 'center' }, message),
            react_1.default.createElement(ButtonGroup, null,
                react_1.default.createElement(StyledButton, { mr: '20px', variant: 'outlineDark', 
                    // close modal if onCancel is not provided
                    onClick: onCancel || props.onClose }, cancelText),
                react_1.default.createElement(StyledButton, { variant: 'dark', onClick: onAction, loadOnClick: true }, actionText)))));
}
exports.default = DialogModal;
var Content = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            padding: '80px 30px'
        },
        _b[theme.mediaQueries.sm] = {
            padding: '80px 60px',
        },
        _b[theme.mediaQueries.md] = {
            padding: '80px 110px',
            maxWidth: 'min(60vw, 650px)',
        },
        _b);
});
var Title = (0, styled_1.default)(Heading_1.default.H2)({
    textAlign: 'center',
    // for mobile, not greater than 60vw, desktop not greater than two buttons plus margin
    maxWidth: 'min(60vw, 460px)',
    margin: 'auto',
    marginBottom: '10px',
});
var StyledButton = (0, styled_1.default)(Button_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            textTransform: 'uppercase',
            width: '100%'
        },
        _b[theme.mediaQueries.sm] = {
            width: '220px',
        },
        _b);
});
var ButtonGroup = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
});
